import { CaretRightIcon } from '@bloomfieldrobotics/canopy';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  accordionSummaryClasses,
  AccordionSummaryProps,
  styled,
  Typography,
} from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  displayDate: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
}>;

const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary expandIcon={<CaretRightIcon />} {...props} />
))(({ theme }) => ({
  padding: theme.spacing(2),
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    [`&.${accordionSummaryClasses.expanded}`]: {
      transform: 'rotate(90deg)',
    },
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

export const RawCountsDateSection = ({
  displayDate,
  expanded,
  onExpandedChange,
  children,
}: Props) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, expanded) => onExpandedChange(expanded)}
      sx={{ width: '100%' }}
      slotProps={{ transition: { timeout: 150 } }}
    >
      <StyledAccordionSummary>
        <Typography variant='subtitle2'>{displayDate}</Typography>
      </StyledAccordionSummary>
      <AccordionDetails
        sx={{
          width: '100%',
          paddingLeft: 4,
          paddingRight: 4,
          paddingTop: 2,
          paddingBottom: 2,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
